import React, { useState } from 'react';
import { ArrowRight, CreditCard } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { fmtDate, fmtMoney, priceUsd } from '@/lib/billingApi';
import { PlanSwitchDialog } from './PlanSwitchDialog';

// Officials add-on renewing through PayPal -> card: $0 card check now, card charged when the paid year ends.
export const OfficialsCardSwitch = ({ sub, cardEnabled }) => {
  const [open, setOpen] = useState(false);
  const { amount, currency } = sub.card_switch;
  const price = fmtMoney(amount, currency);
  const end = fmtDate(sub.current_period_end);
  return (
    <div className="rounded-2xl border-2 border-[#00247D]/20 bg-gradient-to-br from-[#00247D]/5 to-white p-5 sm:p-6 animate-in fade-in slide-in-from-bottom-2 duration-500" data-testid="officials-card-switch">
      <div className="flex items-start gap-3">
        <CreditCard className="w-7 h-7 text-[#00247D] shrink-0" />
        <div className="min-w-0">
          <h3 className="text-2xl sm:text-3xl font-black uppercase text-slate-900 leading-none" style={{ fontFamily: 'Barlow Condensed' }}>Pay for Officials Scheduling by card</h3>
          <p className="text-sm text-slate-600 mt-2" data-testid="officials-card-switch-text">
            No charge today. Confirm your card on the bank's secure page, we turn off your PayPal renewal, and your card is charged {priceUsd(amount)} when your current year ends on {end}. You keep every day you've already paid for.
          </p>
        </div>
      </div>
      <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <Button onClick={() => setOpen(true)} disabled={!cardEnabled} className="bg-[#00247D] hover:bg-[#001A5C] font-bold transition-transform active:scale-[0.98]" data-testid="officials-card-switch-btn">
          Switch to card billing<ArrowRight className="w-4 h-4 ml-1.5" />
        </Button>
        {!cardEnabled && <p className="text-xs text-slate-500">Card payments are temporarily unavailable. Please try again later.</p>}
      </div>
      {open && (
        <PlanSwitchDialog
          onClose={() => setOpen(false)}
          testId="officials-card-switch"
          eyebrow="Switch to card billing"
          title="Officials Scheduling"
          description="Your card is checked for $0.00 today. Nothing is charged until your paid PayPal year ends."
          facts={[
            { label: 'Due today', value: fmtMoney(0, currency), testId: 'officials-card-switch-due' },
            { label: 'PayPal renewal', value: 'Turned off for you' },
            { label: 'Paid through', value: end, testId: 'officials-card-switch-paid-through' },
            { label: 'Card renewal', value: `${price} on ${end}`, testId: 'officials-card-switch-renewal' },
          ]}
          consentText={`I authorise Schedule Guru to charge this card ${price} each year, starting when my current year ends on ${end}, until I cancel.`}
          payLabel="Confirm card ($0.00 today)"
          path="/billing/officials/switch-to-card"
        />
      )}
    </div>
  );
};
